import { TAB_SECTIONS } from "@/app/navigation";
import { NavLink } from "react-router-dom";

export function BottomNav() {
  return (
    <nav className="tabbar" aria-label="Secciones">
      {TAB_SECTIONS.map((section) => (
        <NavLink
          key={section.id}
          to={section.path}
          className={({ isActive }) => (isActive ? "tab tab--active" : "tab")}
        >
          <span className="tab__icon">
            <section.icon size={22} aria-hidden="true" />
          </span>
          <span className="tab__label">{section.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
